<template>
  <transition name="slideout">
    <div
      v-show="slideoutOpen"
      class="mobile-menu-wrapper"
      data-close
      @click="closeMobileMenu($event)"
    >
      <div class="mobile-menu">
        <div class="mobile-menu__header flex items-center justify-between">
          <a
            :href="homeUrl"
            class="mobile-menu__logo"
          >
            <LogoIcon />
            <span class="visually-hidden">{{ shopName }}</span>
          </a>

          <button
            class="close-btn xs font-semibold flex items-center"
            data-close
            @click="closeMobileMenu($event)"
          >
            Close
            <CloseIcon />
          </button>
        </div>

        <div class="mobile-menu__main">
          <div
            v-if="activeSubmenu"
            class="mobile-menu__submenu mobile-menu-navigation"
          >
            <div class="mobile-menu__submenu-header flex items-center">
              <button
                class="close-btn xs font-semibold flex items-center"
                data-close-submenu
                @click="closeSubmenu"
              >
                <ArrowRightSmall />
                Back
              </button>

              <h2 class="mobile-menu__submenu-title sm normal-case font-bold">
                {{ activeSubmenu.title }}
              </h2>
            </div>
            <nav
              class="mobile-menu__submenu-navigation"
              :aria-label="`${activeSubmenu.title} navigation`"
            >
              <ul
                class="mobile-menu-navigation__list"
                role="list"
              >
                <li
                  v-for="link in activeSubmenu.links"
                  :key="`child-link-${link.title}`"
                  class="mobile-menu-navigation__list-item"
                >
                  <a
                    :href="link.url"
                    class="mobile-menu-navigation__link"
                  >
                    <MobileMenuLink :link="link" />
                  </a>
                </li>
                <li
                  v-if="activeSubmenu.url !== '#'"
                  class="mobile-menu-navigation__list-item"
                >
                  <a
                    :href="activeSubmenu.url"
                    class="mobile-menu-navigation__link mobile-menu-navigation__link--shop-all"
                  >
                    Shop all
                    <ArrowRightSmall />
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <template v-else>
            <a
              v-if="tryNow.enable"
              :href="tryNow.url"
              class="mobile-menu__try-cta btn--red"
            >
              <LightningFilledIcon />
              {{ tryNow.text }}
            </a>

            <nav
              v-if="navigationLinks.length > 0"
              class="mobile-menu-navigation"
              aria-label="Main Mobile Navigation"
            >
              <ul
                class="mobile-menu-navigation__list"
                role="list"
              >
                <li
                  v-for="(link, i) in navigationLinks"
                  :key="`parent-link-${link.title}`"
                  class="mobile-menu-navigation__list-item"
                >
                  <button
                    v-if="link.links.length > 0"
                    class="mobile-menu-navigation__link"
                    @click="openSubmenu(i)"
                  >
                    <MobileMenuLink :link="link" />
                  </button>

                  <a
                    v-else
                    :href="link.url"
                    class="mobile-menu-navigation__link"
                  >
                    <MobileMenuLink :link="link" />
                  </a>
                </li>
              </ul>
            </nav>
          </template>

          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import LogoIcon from '../icons/logo-icon'
import CloseIcon from '../icons/close-icon'
import LightningFilledIcon from '../icons/lightning-filled'
import ArrowRightSmall from '../icons/arrow-right-small'

import MobileMenuLink from './mobile-menu-link'

import { useMobileMenuStore } from '../pinia/MobileMenuStore'

import { mapActions, mapState } from 'pinia'

export default {
  components: {
    LogoIcon,
    CloseIcon,
    LightningFilledIcon,
    ArrowRightSmall,
    MobileMenuLink
  },
  props: {
    tryNow: {
      type: Object,
      default: () => {
        return {
          enable: false
        }
      }
    },
    navigationData: {
      type:Array,
      default: null
    }
  },
  data () {
    return {
      isOpen: false,
      navigationLinks: [...this.navigationData],
      activeSubmenu: null
    }
  },
  computed: {
    ...mapState(useMobileMenuStore, ['slideoutOpen']),
    homeUrl () {
      return window.theme.shop.url
    },
    shopName () {
      return window.theme.shop.name
    },
  },
  mounted () {
    this.locationDropdownToggle()
  },
  methods: {
    ...mapActions(useMobileMenuStore, [
      'closeSlideout'
    ]),
    closeMobileMenu (e) {
      if (e && e.target.hasAttribute('data-close')) {
        this.closeSlideout()
        this.activeSubmenu = null
      }
    },
    openSubmenu (index) {
      this.activeSubmenu = this.navigationLinks[index]
    },
    closeSubmenu (e) {
      if (e && e.target.hasAttribute('data-close-submenu')) {
        this.activeSubmenu = null
      }
    },
    locationDropdownToggle () {
      const locationPicker = document.querySelector('.mobile-menu .location-picker')
      if (locationPicker) {
        locationPicker.querySelector('.location-picker__active').addEventListener('click', () => {
          locationPicker.classList.toggle('closed')
        })
      }
    }
  }

}
</script>
